<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              <router-link :to="{ name: 'configuracion' }">
                {{ $t("configuracionCarta") }}</router-link
              >
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("importacionSinqro") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label for="listBusiness"
                  ><strong>{{ $t("negocio") }}</strong></label
                >
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  @change="permisoCarta()"
                  :placeholder="this.$i18n.t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-5" v-if="listCartas.length > 1">
              <div class="form-group">
                <label
                  ><strong>{{ $t("cartaASecas") }}</strong></label
                >
                <el-select
                  class="select-default"
                  size="large"
                  v-model="idCarta"
                  @change="getProductosCarta()"
                  filterable
                  :placeholder="$t('seleccionaUnaCarta')"
                >
                  <el-option
                    v-for="cart in listCartas"
                    class="select-primary"
                    :value="cart.id"
                    :label="cart.nombreMostrado"
                    :key="cart.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--TABLA DE GESTION DE CONFIGURACION DE CARTA-->

      <template v-if="permiso === 1"> </template>
      <template v-else-if="permiso && respuesta">
        <div class="col-md-5 text-right">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-bind:placeholder="$t('buscar')"
              v-model="searchQuery"
              @keyup.enter.prevent="searchProductoCarta()"
            />
            <div class="input-group-append">
              <button
                class="btn btn-secondary"
                type="button"
                @click="searchProductoCarta"
              >
                <i class="fa fa-search"></i>
              </button>
              <button
                class="btn btn-secondary"
                type="button"
                @click="removeProductoCarta()"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-12" v-for="cat in listProductosCarta">
          <p
            style="
              color: #1E22AA;
              margin: 10px 0px;
              font-size: 25px;
              font-family: 'Numier', 'Helvetica Neue', Arial;
              font-weight: bold;
            "
          >
            {{ cat.nombre }}
          </p>

          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead-dark">
                <tr>
                  <th>{{ $t("imagen") }}</th>
                  <th v-if="activeCarta && listCartas.length > 1">
                    {{ $t("carta") }}
                  </th>
                  <th v-if="!idTipo">{{ $t("tipo") }}</th>
                  <th>{{ $t("nombre") }}</th>
                  <th>{{ $t("nombreEnTpv") }}</th>
                  <th class="text-center">{{ $t("precio") }}</th>
                  <th class="text-center" v-if="distinguirPrecios">
                    {{ $t("precio") + " " + $t("aDomicilio") }}
                  </th>
                  <th class="text-center">{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obj in cat.productos">
                  <td width="5%">
                    <div>
                      <template v-if="obj.img">
                        <img
                          @click="openModalEditar(obj)"
                          width="100%"
                          :src="obj.img + '?' + obj.updated"
                        />
                      </template>
                      <template v-else>
                        <img
                          @click="openModalEditar(obj)"
                          width="100%"
                          src="https://www.numier.com/cartadigital/no-products.png"
                        />
                      </template>
                    </div>
                  </td>
                  <td v-if="activeCarta && listCartas.length > 1">
                    <div>
                      {{ obj.nombreCarta }}
                    </div>
                  </td>
                  <td v-if="!idTipo">
                    <div>
                      <template v-if="obj.tipoCarta === 'C'">{{
                        $t("cartaASecas")
                      }}</template>
                      <template v-else-if="obj.tipoCarta === 'P'">{{
                        $t("pedido")
                      }}</template>
                      <template v-else>{{ $t("cartaYPedido") }}</template>
                    </div>
                  </td>

                  <td>
                    <div>
                      <span
                        v-bind:style="[
                          !obj.noDisponible
                            ? { 'text-decoration': 'line-through' }
                            : {},
                        ]"
                        >{{ obj.nameProducto }}</span
                      >
                      <span style="color: red" v-if="obj.baja">
                        [{{ $t("BAJA") }}]
                      </span>
                    </div>
                  </td>

                  <td>
                    <div>
                      <span
                        v-bind:style="[
                          !obj.noDisponible
                            ? { 'text-decoration': 'line-through' }
                            : {},
                        ]"
                        >{{ obj.nombreProductoRef }}</span
                      >
                    </div>
                  </td>
                  <td align="right">
                    <div>
                      <span
                        v-bind:style="[
                          !obj.noDisponible
                            ? { 'text-decoration': 'line-through' }
                            : {},
                        ]"
                        >{{ obj.precioTarifa1 | currency }}</span
                      >
                    </div>
                  </td>
                  <td v-if="distinguirPrecios" align="right">
                    <div>
                      <span
                        v-bind:style="[
                          !obj.noDisponible
                            ? { 'text-decoration': 'line-through' }
                            : {},
                        ]"
                        >{{ obj.precioTarifa1_d | currency }}</span
                      >
                    </div>
                  </td>
                  <td align="center">
                    <i
                      class="fas fa-globe-americas" style="color: #1F51FF"
                    ></i>
                    <!-- <i class="fas fa-globe-americas" style="color: #1F51FF" @click="categoriasSinqro()"></i> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template v-if="!permiso">
        <div class="col-md-12">
          <div class="alert alert-primary" align="center">
            <h3>
              <i class="fas fa-exclamation-circle"></i>
              {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
            </h3>

            <span>
              {{ $t("paraMasInformacionContacteConSu") }}
              <strong>{{ $t("distribuidor") }}</strong
              >.</span
            >
          </div>
        </div>
      </template>
    </div>

    <modal
      name="modalReply"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("replicarTodosLosProductos") }}</h4>
        </div>
        <div class="modal-body">
          <input
            type="checkbox"
            id="checkSelectAll"
            name="checkSelectAll"
            v-model="checkSelectAll"
            @click="selectAll"
          />
          <label for="checkSelectAll" class="checkSelectAll">{{
            $t("seleccionarTodos")
          }}</label>

          <div v-for="business in listBusinessReply">
            <el-checkbox
              v-if="business.id != idBusiness"
              v-model="business.checked"
              border
              class="checkbox-element"
              style="width: 100%"
            >
              {{ business.establishmentName }}
            </el-checkbox>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="$modal.hide('modalReply')">
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button class="btn btn-primary" @click="modalConfirmation">
            <i class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>

    <modal
      :name="'editar-producto'"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("editarImagen") }}</h4>
        </div>

        <div class="modal-body">
          <template v-if="productoEditar.img">
            <p>
              <strong>{{ $t("imagen") }}</strong>
              <span style="color: red">*</span>
              <i
                class="fas fa-pencil-alt text-warning"
                @click="productoEditar.img = ''"
                v-tooltip.top-center="$t('editarImagen')"
              ></i>
            </p>
            <div style="width: 100%">
              <img
                width="100%"
                :src="productoEditar.img + '?' + productoEditar.updated"
              />
            </div>
          </template>
          <template v-else>
            <div class="form-group">
              <label
                ><strong>{{ $t("imagen") }}</strong>
              </label>
              <input
                class="form-control"
                type="file"
                style="height: 100px"
                @change="onFileChange"
              />
              <br />
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-default"
            @click="(img = ''), $modal.hide('editar-producto')"
          >
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button class="btn btn-success" @click="editarImagen(productoEditar)">
            <i class="fa fa-check-circle"></i>
            {{ $t("guardar") }}
          </button>
        </div>
      </div>
    </modal>
    <modal
      :name="'anadir-idioma'"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">
            Traducir a Inglés: {{ productoEditar.nameProducto }}
          </h4>
        </div>

        <div class="modal-body">
          <div id="ingles">
            <label for="traduccion">Nombre: </label>
            <input
              id="traduccion"
              class="form-control"
              type="text"
              v-model="productoEditar.traduccion"
            />
            <label for="traduccion">Descripcion: </label>
            <input
              class="form-control"
              type="text"
              v-model="productoEditar.traduccionDesc"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-default"
            @click="(img = ''), $modal.hide('anadir-idioma')"
          >
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button
            class="btn btn-success"
            @click="cambiarIdiomaAProducto(productoEditar)"
          >
            <i class="fa fa-check-circle"></i>
            {{ $t("guardar") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

export default {
  name: "ConfiguracionCarta",

  created() {
    this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
    this.getBusiness();
    this.$store.dispatch("setNameRoute", "Productos carta");
  },
  data() {
    return {
      listTipoProducto: [
        {
          value: "",
          label: this.$t("todos"),
        },
        {
          value: "P",
          label: this.$t("pedidos"),
        },
        {
          value: "C",
          label: this.$t("cartaASecas"),
        },
      ],
      idTipo: "",
      cacheImagen: 0,
      searchQuery: "",
      img: "",
      listProductosCarta: [],
      productoEditar: {},
      listBusinesses: [],
      idBusiness: 0,
      permiso: 1,
      nameRoute: "",
      logoNegocio: "",

      tipoCarta: false,
      tipoPedido: false,
      activeCarta: false,
      listCartas: [],
      idCarta: 0,
      respuesta: false,
      tokenServerSinqro: "",
      tokenUserSinqro: "",
      productoSeleccionado: undefined,
      relacionProductSubproductCarta: [],
      listaIdsProductsCategory: [],
      categoriesSinqroList: [],
      listaRefs: [],
      productsOptionList: [],
      listaRefsProductOptions: [],
      category: {},
      nombreTipo: "",
      idCategorySinqro: 0,
      llamar: true,
      lang: "en",
      configcarta: {},

      //REPLY
      listBusinessReply: [],
      checkSelectAll: false,
      distinguirPrecios: false,
      loadingGeneral: null,
    };
  },
  methods: {
    ////////////////                 Viejo               ///////////////////
    /**********************************************************************/
    /**********************************************************************/
    /**********************************************************************/
    /**********************************************************************/
    /**********************************************************************/
    /**********************************************************************/
    /**********************************************************************/
    /**********************************************************************/
    /**********************************************************************/
    /**********************************************************************/
    // addSinqro(element) {
    //   var vm = this;
    //   var prodSelected = element.producto;

    //   var config = {
    //     headers: {
    //       "x-api-server-access-token": this.tokenServerSinqro,
    //       "x-api-user-access-token": this.tokenUserSinqro,
    //     },
    //   };

    //   if (prodSelected == undefined) {
    //     console.log("Indefinido");
    //   } else {
    //     var productoInputData = {
    //       name: prodSelected.nameProducto,
    //       externalId: prodSelected.id,
    //       price: {
    //         amount: prodSelected.precio,
    //         vatValue: "10",
    //       },
    //       inMenuPrice: {
    //         amount: prodSelected.precio + 3,
    //         vatValue: "10",
    //       },
    //       shortDescription: "Producto de Numier",
    //       description: "a ver si es posible hacer la importacion",
    //       image: {
    //         filename: "",
    //         data: "", //"data:image/jpeg;base64,/9j/4A..."
    //       },
    //       public: true,
    //       featured: false,
    //       isAvailable: true,
    //       addProductOptionsToVariants: false,
    //       productVariants: [],
    //       tags: [],
    //       productOptionsIds: categoryList,
    //     };

    //     this.listaProductosSinqro.push(productoInputData);
    //     console.log(this.listaProductosSinqro);
    //     // vm.axios
    //     //   .post(
    //     //     "https://api.sinqro.com/pos-app/v1/sellingPoints/3582/products",
    //     //     productoInputData,
    //     //     config
    //     //   )
    //     //   .then(function(response) {
    //     //     console.log(response);
    //     //     vm.listaProductosSinqro.push(productoInputData);
    //     //   });
    //   }
    // },

    // editarCategorySinqro() {},

    // imprimir() {
    //   console.log("Prod con sub prod");
    //   console.log(this.listaProdConSubProd);

    //   console.log("Prod sinqro");
    //   console.log(this.listaProductosSinqro);

    //   console.log("Cat sinqro");
    //   console.log(this.listaCategoriasSinqro);
    // },

    // /*----------------------------------------------------*/
    // fullSinqroImportByIdBussines() {
    //   //this.loadingGeneral = Loading.service({text: this.$t('cargando')});
    //   var count = 0;
    //   var vm = this;
    //   var jwt =
    //     "jwt=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZFVzZXIiOiIyMDQwIiwiZW1haWwiOiJkaWVnb0B0YWN0aWx3YXJlLmNvbSJ9.I5Dtn4u9xnvy-4ovqkLJSExBQqYj-ByGIfI9rIzEbAU";

    //   var productsByIdBussines = []; //All products
    //   this.listProductosCarta.forEach((categoria) => {
    //     productsByIdBussines = productsByIdBussines.concat(categoria.productos);
    //   });

    //   for (let index = 0; index < 15; index++) {
    //     const element = productsByIdBussines[index];
    //     vm.axios
    //       .get(
    //         "http://192.168.1.44:8082/products/getProductCarta?idBusiness=" +
    //           vm.idBusiness +
    //           "&" +
    //           jwt +
    //           "&idProduct=" +
    //           element.id
    //       )
    //       .then(function(response) {
    //         vm.productoSeleccionado = response.data;

    //         vm.getSubProdSinqro(response.data);
    //       })
    //       .catch(function(error) {
    //         console.log(error);
    //         vm.loadingGeneral.close();
    //       });
    //   }

    //   // productsByIdBussines.forEach(element => {
    //   //   vm.axios
    //   //   .get(
    //   //     "http://192.168.1.44:8082/products/getProductCarta?idBusiness=" +
    //   //       vm.idBusiness +
    //   //       "&" +
    //   //       jwt +
    //   //       "&idProduct=" +
    //   //       element.id
    //   //   )
    //   //   .then(function(response) {
    //   //     vm.productoSeleccionado = response.data;

    //   //     vm.getSubProdSinqro(response.data);

    //   //   })
    //   //   .catch(function(error) {
    //   //     console.log(error);
    //   //     vm.loadingGeneral.close();
    //   //   });

    //   // });

    //   // productsByIdBussines.forEach((element) => {
    //   //   this.addSinqro(element, idBusiness);
    //   // });
    // },
    // //AGREGA PRODUCTO A SINQRO
    // addSinqro(producto) {
    //   console.log(index);
    //   //this.loadingGeneral = Loading.service({text: this.$t('cargando')});
    //   var vm = this;
    //   var jwt =
    //     "jwt=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZFVzZXIiOiIyMDQwIiwiZW1haWwiOiJkaWVnb0B0YWN0aWx3YXJlLmNvbSJ9.I5Dtn4u9xnvy-4ovqkLJSExBQqYj-ByGIfI9rIzEbAU";

    //   //coge el producto en concreto de la api
    //   vm.axios
    //     .get(
    //       "http://192.168.1.44:8082/products/getProductCarta?idBusiness=" +
    //         vm.idBusiness +
    //         "&" +
    //         jwt +
    //         "&idProduct=" +
    //         producto.id
    //     )
    //     .then(function(response) {
    //       vm.productoSeleccionado = response.data;

    //       console.log(index);

    //       //vm.getSubProdSinqro(producto);
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //       vm.loadingGeneral.close();
    //     }); //cierre function axios producto
    // },
    // //OBTIENE LOS SUBPRODUCTOS DEL PLATO
    // getSubProdSinqro(producto) {
    //   var vm = this;
    //   var jwt =
    //     "jwt=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZFVzZXIiOiIyMDQwIiwiZW1haWwiOiJkaWVnb0B0YWN0aWx3YXJlLmNvbSJ9.I5Dtn4u9xnvy-4ovqkLJSExBQqYj-ByGIfI9rIzEbAU";

    //   this.axios
    //     .get(
    //       "http://192.168.1.44:8082/products/getProductSubproductCarta?idBusiness=" +
    //         vm.idBusiness +
    //         "&" +
    //         jwt +
    //         "&idProduct=" +
    //         producto.id
    //     )
    //     .then(function(responseSubproduct) {
    //       vm.relacionProductSubproductCarta = responseSubproduct.data;
    //       // console.log(responseSubproduct.data);
    //       responseSubproduct.data.forEach((element) => {
    //         if (element.idRef == null) {
    //           // console.log(producto.id)
    //           // console.log(element);
    //           // console.log("============================================")
    //           vm.crearProductoSinqro([], producto);
    //         } else {
    //           // console.log(producto.id)
    //           // console.log(element);
    //           // console.log("!============================================!")

    //           vm.generarCategorySinqro(responseSubproduct.data, producto);
    //         }
    //       });
    //       //Genera productsOptions
    //     });
    //   // .catch(function(error) {
    //   //   console.log(error);
    //   //   vm.loadingGeneral.close();
    //   // });
    // },
    // // GENERA LAS CATEGIORIAS PARA PODER CREAR MAS ADELANTE EL PRODUCTO
    // generarCategorySinqro(listaRelaciones, producto) {
    //   var vm = this;

    //   var config = {
    //     headers: {
    //       "x-api-server-access-token": vm.tokenServerSinqro,
    //       "x-api-user-access-token": vm.tokenUserSinqro,
    //     },
    //   };

    //   vm.axios
    //     .get(
    //       "https://api.sinqro.com/pos-app/v1/sellingPoints/3582/productOptionsCategories/",
    //       config
    //     )
    //     .then(function(responseCat) {
    //       vm.categoriesSinqroList = responseCat.data;
    //       //console.log(responseCat.data);
    //       vm.preparacionCategorySinqro(
    //         listaRelaciones,
    //         producto,
    //         responseCat.data
    //       );
    //     });

    //   //vm.crearCategorySinqro(categoriesList);
    // },
    // preparacionCategorySinqro(listaRelaciones, producto, categoriesList) {
    //   //console.log(listaRelaciones);
    //   //console.log(producto);
    //   //console.log(categoriesList);
    //   var vm = this;
    //   var name = "";
    //   var description = "";
    //   var position = 1;
    //   var idCategorySinqro = 0;
    //   var categoriesSinqroList = [];

    //   listaRelaciones.forEach(function(element, i) {
    //     var jsonCategory = undefined;
    //     vm.listaRefs.push(element.idSubProduct);

    //     //Crear solo un array de subProductos y añadir a la lista de la categoria (productOptions) y hacer patch de la category
    //     var jsonSubproducts = {
    //       name: element.subProdName,
    //       externalId: element.idSubProduct,
    //       shortDescription: "Short description",
    //       position: i,
    //       isAvailable: true,
    //       price: {
    //         amount: element.variacion_precio,
    //         vatValue: 10.0,
    //       },
    //     };
    //     vm.productsOptionList.push(jsonSubproducts);
    //     var nextIndex = i + 1;
    //     //Comprueba si hay siguiente categoria en el producto
    //     if (
    //       listaRelaciones[nextIndex] == undefined ||
    //       listaRelaciones[i].tipo != listaRelaciones[nextIndex].tipo
    //     ) {
    //       //Lista de subproducs del mismo tipo --> vm.productsOptionList
    //       if (element.tipo == "E") {
    //         vm.nombreTipo = "(EXTRAS) Añade lo que quieras";
    //       } else if (element.tipo == "O") {
    //         vm.nombreTipo = "(Opcionales) Elige uno";
    //       } else if (element.tipo == "B") {
    //         vm.nombreTipo = "(BASES) ¿Quieres quitar algo?";
    //       } else {
    //         console.log("Tipo diferente");
    //         vm.nombreTipo = "Categoria varios";
    //       }
    //       var productOption = vm.productsOptionList;
    //       vm.productsOptionList = [];
    //       position++;
    //       // Comprobar nombreTipo con vm.categoriesSinqroList.
    //       // Si la categoria coincide --> se edita la categoria y se añade el subproducto.
    //       // Si la categoria no coincide --> crear categoria con subproductos.
    //       // En ambos casos hay que guardar los ids de los subproductos para la relacion con el producto.
    //       //console.log( vm.categoriesSinqroList);
    //       console.log("===============================================");
    //       console.log(categoriesList);

    //       categoriesList.forEach((elementCat) => {
    //         if (elementCat.name == vm.nombreTipo) {
    //           // Tipo encontrado en sinqro
    //           jsonCategory = elementCat;
    //           vm.idCategorySinqro = elementCat.id;
    //         } else if (vm.nombreTipo == "") {
    //           jsonCategory = elementCat;
    //           // Tipo desconocido
    //         } else {
    //           jsonCategory = elementCat;
    //           // Tipo no encontrado en sinqro
    //         }
    //       });

    //       if (jsonCategory == undefined) {
    //         jsonCategory = { name: vm.nombreTipo };
    //       }
    //       // Si la variable idCategorySinqro es 0 --> la categoria no existe.
    //       // Si la categoria existe hay que hacer patch con id de categoria --> vm.idCategorySinqro
    //       // y añadir a esta categoria la lista de subproductos -->  productOption Ó vm.productsOptionList
    //       if (vm.idCategorySinqro == 0) {
    //         // Crear
    //         console.log(productOption);
    //         console.log(producto);
    //         console.log(jsonCategory);
    //         vm.createCategorySinqro(productOption, producto, jsonCategory);
    //       } else {
    //         //Editar
    //         vm.patchCategorySinqro(jsonCategory, productOption, producto);
    //       }
    //     }
    //   });
    // },

    // createCategorySinqro(productsOptionList, producto, jsonCategory) {
    //   var vm = this;
    //   var config = {
    //     headers: {
    //       "x-api-server-access-token": vm.tokenServerSinqro,
    //       "x-api-user-access-token": vm.tokenUserSinqro,
    //     },
    //   };
    //   var jsonCategoryCreate = {
    //     id: null,
    //     name: jsonCategory.name,
    //     shortDescription: "Description",
    //     position: 1,
    //     maxSelection: 10,
    //     minSelection: null,
    //     maxSameOptionSelection: 2,
    //     selectionLabel: "Max. 10",
    //     productOptions: productsOptionList,
    //   };
    //   this.axios
    //     .post(
    //       "https://api.sinqro.com/pos-app/v1/sellingPoints/3582/productOptionsCategories",
    //       jsonCategoryCreate,
    //       config
    //     )
    //     .then(function(responseCatPost) {
    //       console.log(responseCatPost);
    //       vm.category = responseCatPost.data;
    //       vm.category.productOptions.filter((c) => {
    //         vm.listaRefs.forEach((element) => {
    //           if (c.externalId == element) {
    //             vm.listaRefsProductOptions.push(c.id);
    //           }
    //         });
    //       });
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //       vm.loadingGeneral.close();
    //     });
    //   var categoryList = vm.listaRefsProductOptions;
    //   if (vm.llamar == true) {
    //     console.log(categoryList + " --> create");
    //     vm.crearProductoSinqro(categoryList, producto);
    //     vm.llamar = false;
    //   }
    // },
    // //EDITA (PARCHEA) LAS CATEGORIAS DE LOS PRODUCTOS PARA GUARDARLOS EN DIFERENTES LISTAS DEPENDIENDO DEL TIPO DE SUBPRODUCTO
    // patchCategorySinqro(jsonCategory, productsOptionList, producto) {
    //   var vm = this;
    //   var config = {
    //     headers: {
    //       "x-api-server-access-token": vm.tokenServerSinqro,
    //       "x-api-user-access-token": vm.tokenUserSinqro,
    //     },
    //   };

    //   console.log("Categoria de sinqro " + jsonCategory);
    //   console.log("Subroductos para añadir " + productsOptionList);

    //   var preEdit = jsonCategory.productOptions.concat(productsOptionList);
    //   jsonCategory.productOptions = preEdit;
    //   this.axios
    //     .patch(
    //       "https://api.sinqro.com/pos-app/v1/sellingPoints/3582/productOptionsCategories/" +
    //         jsonCategory.id,
    //       jsonCategory,
    //       config
    //     )
    //     .then(function(response) {
    //       vm.category = response.data;
    //       vm.category.productOptions.filter((c) => {
    //         vm.listaRefs.forEach((element) => {
    //           if (c.externalId == element) {
    //             vm.listaRefsProductOptions.push(c.id);
    //           }
    //         });
    //       });
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //       vm.loadingGeneral.close();
    //     });

    //   var categoryList = vm.listaRefsProductOptions;

    //   if (vm.llamar == true) {
    //     console.log(categoryList + " --> patch");
    //     vm.crearProductoSinqro(categoryList, product);
    //     vm.llamar = false;
    //   }
    // },
    // //CREA UN PRODUCTO PARA AGREGARLO A SINQRO MAS ADELANTE

    // //==========================================================================================================================================//
    // categoriasSinqro(nomCategoria) {
    //   var vm = this;

    //   var config = {
    //     headers: {
    //       "x-api-server-access-token": vm.tokenServerSinqro,
    //       "x-api-user-access-token": vm.tokenUserSinqro,
    //     },
    //   };

    //   //obtenemos las categorias
    //   vm.axios
    //     .get(
    //       "https://api.sinqro.com/pos-app/v1/sellingPoints/3582/productOptionsCategories/",
    //       config
    //     )
    //     .then(function(responseCategoria) {
    //       if (responseCategoria.data.name != nomCategoria) {
    //       }

    //       //comprobar que si estan creadas, si lo estan, actualizarlas (Patch)

    //       //comparar nombre del nuevo json de subproducto con el existente
    //       //Si no estan creadas, crearlas (Post)
    //     });
    // },
    //==========================================================================================================================================//

    cambiarIdiomaAProducto(obj) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusinessInfo: this.idCarta,
        producto: obj,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "cambiarIdiomaAProducto";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getProductosCarta();
            vm.$modal.hide("anadir-idioma");

            vm.img = "";

            let notify = vm.$t("editada");
            vm.$notify({
              message:
                vm.$t("imagen") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    abrirModalIdiomas(producto) {
      this.productoEditar = producto;
      this.$modal.show("anadir-idioma");
    },
    //REPLICADO
    getBusinessReplicado() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var vm = this;
      this.axios
        .get(
          vm.$store.getters.apiUrl + "general/getBusinessesByUserReplicado",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.listBusinessReply = response.data.result;
            vm.$modal.show("modalReply");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getConfigDistinguirPrecios() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 55,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.distinguirPrecios = true;
          } else {
            vm.distinguirPrecios = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    openModalEditar(obj) {
      this.cacheImagen++;

      this.productoEditar = obj;

      this.$modal.show("editar-producto");

      //this.searchProducto(obj.nombreProductoRef);
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.listBusinesses = response.data.result;

          vm.permisoCarta();
          vm.getConfigDistinguirPrecios();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    permisoCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          estado: this.estado,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getPermisoCarta", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listCartas = [
              {
                nombreMostrado: vm.$t("esteNegocioNoContieneNingunaCarta"),
                id: 0,
              },
            ];
            vm.idCarta = 0;

            if (response.data.result.permiso) {
              vm.permiso = response.data.result.permiso;

              //vm.nameRoute = response.data.result.nameroute;
              //vm.logoNegocio = response.data.result.imagen;

              vm.listCartas = response.data.result.listCartas;

              response.data.result.listCartas.forEach(function(x) {
                if (x.tokenServerSinqro) {
                  vm.tokenServerSinqro = x.tokenServerSinqro;
                }

                if (x.tokenUserSinqro) {
                  vm.tokenUserSinqro = x.tokenUserSinqro;
                }
              });

              vm.idCarta = response.data.result.listCartas[0].id;

              vm.getProductosCarta();
            } else {
              vm.permiso = response.data.result.permiso;
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loadingGeneral.close();
        });
    },

    searchProductoCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          query: this.searchQuery
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl +
            "delivery/searchProductosCarta",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.activeCarta = vm.searchQuery === "" ? false : true;

            vm.listProductosCarta = response.data.result;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    editarImagen(obj) {
      if (!obj.img) {
        obj.editImage = true;

        obj.img = this.img;
      }
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        producto: obj,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "editarImagenProductoCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getProductosCarta();
            vm.$modal.hide("editar-producto");

            vm.img = "";

            let notify = vm.$t("editada");
            vm.$notify({
              message:
                vm.$t("imagen") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    changeNoDisponible(id, baja) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        idProducto: id,
        baja: baja,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "updateDisponibleProducto";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getProductosCarta();

            let notify = vm.$t("editado");
            vm.$notify({
              message:
                vm.$t("producto") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    getProductosCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idTipo: this.idTipo,
          idCarta: this.idCarta,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getProductsCarta", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listProductosCarta = response.data.result;
            vm.respuesta = true;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
      const tempconfig = this.listCartas.find((elm) => elm.id == this.idCarta)
        .config;

      if (tempconfig && tempconfig.length > 0) {
        tempconfig.forEach((element) => {
          const el = {};
          el[element.nombre] = element.valor != 0;
          Object.assign(this.configcarta, el);
          //  this.configcarta.push(el)
        });
      }
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.img = e.target.result;
      };
      reader.readAsDataURL(file);
      // vm.getBase64(file);
    },

    removeProductoCarta() {
      this.activeCarta = false;
      this.searchQuery = "";
      this.getProductosCarta();
    },

    modalConfirmation() {
      swal({
        title: this.$t(
          "estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados"
        ),
        text: this.$t("estaAccionNoSePuedeDeshacer"),
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siReplicar"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.replyProducts();
        }
      });
    },
    replyProducts() {
      var listBuinessReply = this.listBusinessReply.filter(
        (bussines) => bussines.checked
      );

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      var params = {
        idBusiness: this.idBusiness,
        listBusinesses: listBuinessReply,
        idCarta: this.idCarta,
        jwt: this.$store.getters.jwt,
      };
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/replyAllProducts",
          params,
          config
        )
        .then(function(response) {
          vm.$modal.hide("modalReply");

          // if (response.data.response) {
          //     vm.closeModal();
          // } else {
          //     swal({
          //         title: `Atención`,
          //         text: response.data.message,
          //         confirmButtonClass: 'btn btn-info btn-fill',
          //         type: 'error'
          //     });
          //
          //
          // }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    selectAll() {
      if (this.checkSelectAll) {
        this.listBusinesses.forEach(function(business) {
          business.checked = false;
        });
      } else {
        this.listBusinesses.forEach(function(business) {
          business.checked = true;
        });
      }
    },
  },

  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Option.name]: Option,
  },
};
</script>

<style scoped>
tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
  cursor: pointer;
}

td div {
  padding: 12px 8px;
  color: #333;
}

.buttonsSearch:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.1);
}

.card {
  padding: 20px;
}

.input-group button {
  height: 40px;
}

.botonTotal {
  border: 1px solid #28a745;
  color: #ffffff;
  background-color: #28a745;
  font-weight: 400;
  padding: 8px 16px;
  /* cursor: pointer; */
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 1.42857143;
}

.nombreProducto {
  color: #fff;
  background-color: #0e0e0e;
  text-shadow: 1px 1px #333;
  font-weight: 700;
  font-size: 15px;
}

.tituloPedido {
  color: #1E22AA;
  font-family: "Numier", "Helvetica Neue", Arial;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Sinqro/ImportacionSinqro.vue